import { ERROR_API_ENDPOINT_BLACKLIST, SUCCESS_API_ENDPOINT_WHITELIST } from "../../util/constants";
import { isFulfilled, isRejected } from "@reduxjs/toolkit";

// optimized sets created from whitelisted/blacklisted calls to display custom msg from backend
const SUCCESS_ENDPOINTS = new Set(Object.values(SUCCESS_API_ENDPOINT_WHITELIST));
const ERROR_IGNORED_ENDPOINTS = new Set(Object.values(ERROR_API_ENDPOINT_BLACKLIST));

const AlertEndpointManager = (action) => {
  const isRejectedAction = isRejected(action) ?? false
  const isFulfilledAction = isFulfilled(action) ?? false
  const endpointName = action.meta?.arg?.endpointName;
  const doNotShowAlert = { isRejectedAction: false, isFulfilledAction: false }

  // return early if certain conditions are met
  if (isRejectedAction && ERROR_IGNORED_ENDPOINTS.has(endpointName))
    return doNotShowAlert

  if (isFulfilledAction && !SUCCESS_ENDPOINTS.has(endpointName))
    return doNotShowAlert

  return { isRejectedAction, isFulfilledAction }
}

export default AlertEndpointManager